import React, { useContext, useState } from 'react';
import { Pane, Table, Heading } from 'evergreen-ui';
import NucleoContext from '../../../../context/NucleoContext';

export default function Gerente() {
  const {
    processSelect,
  } = useContext(NucleoContext);
  const [gerenteProcesso] = useState(processSelect.processo.gerente);

  return (
    <Pane padding={10}>
      <Heading size={600} className="mb10">
        Dados do Gerente
      </Heading>
      <Pane>
        <Table.Row>
          <Table.TextCell flexBasis={250} flexShrink={0} flexGrow={0} className='wsNormal'>
            <span className="fontStatus">CPF</span><br />
            {gerenteProcesso.data[0].cpf_cnpj || '---'}
          </Table.TextCell>
          <Table.TextCell flexBasis={250} flexShrink={0} flexGrow={0} className='wsNormal'>
            <span className="fontStatus">Telefone/Celular</span><br />
            {gerenteProcesso.data[0].telefone || '---'}
          </Table.TextCell>
        </Table.Row>

        <Table.Row>
          <Table.TextCell flexBasis={600} flexShrink={0} flexGrow={0}>
            <span className="fontStatus">Nome completo</span><br />
            {gerenteProcesso.data[0].name || '---'}
          </Table.TextCell>
        </Table.Row>

        <Table.Row>
          <Table.TextCell flexBasis={250} flexShrink={0} flexGrow={0}>
            <span className="fontStatus">Data de nascimento</span><br />
            {gerenteProcesso.data[0].data_nascimento || '---'}
          </Table.TextCell>
          <Table.TextCell flexBasis={250} flexShrink={0} flexGrow={0}>
            <span className="fontStatus">Nacionalidade</span><br />
            {gerenteProcesso.data[0].nacionalidade || '---'}
          </Table.TextCell>
        </Table.Row>

        <Table.Row>
          <Table.TextCell flexBasis={250} flexShrink={0} flexGrow={0}>
            <span className="fontStatus">Estado Civil</span><br />
            {gerenteProcesso.data[0].estado_civil || '---'}
          </Table.TextCell>
          <Table.TextCell flexBasis={250} flexShrink={0} flexGrow={0}>
            <span className="fontStatus">Profissão</span><br />
            {gerenteProcesso.data[0].profissao || '---'}
          </Table.TextCell>
          <Table.TextCell flexBasis={250} flexShrink={0} flexGrow={0}>
            <span className="fontStatus">R.G</span><br />
            {gerenteProcesso.data[0].rg || '---'}
          </Table.TextCell>
        </Table.Row>

        <Table.Row>
          <Table.TextCell flexBasis={600} flexShrink={0} flexGrow={0}>
            <span className="fontStatus">E-mail</span><br />
            {gerenteProcesso.data[0].email || '---'}
          </Table.TextCell>
        </Table.Row>
      </Pane>

    </Pane>
  )
}